import { render, staticRenderFns } from "./MedicalRepPlan.vue?vue&type=template&id=78054fc4"
import script from "./MedicalRepPlan.vue?vue&type=script&lang=js"
export * from "./MedicalRepPlan.vue?vue&type=script&lang=js"
import style0 from "./MedicalRepPlan.vue?vue&type=style&index=0&id=78054fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports